'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
/* Grays */

var charcoal = exports.charcoal = '#323232';

var graphite = exports.graphite = '#5C5D5C';

var onyx = exports.onyx = '#434343';

var slate = exports.slate = '#4c4c4c';

var ash = exports.ash = '#6f6f6f';

var steel = exports.steel = '#818181';

var chalice = exports.chalice = '#ADADAD';

var silver = exports.silver = '#BCBCBC';

var titanium = exports.titanium = '#D8D8D8';

var mercury = exports.mercury = '#E9E9E9';

var cloud = exports.cloud = '#EEEEEE';

var offwhite = exports.offwhite = '#F5F5F5';

/* Colors */

var blue = exports.blue = '#35A7F8';

var mint = exports.mint = '#59D698';

var turquoise = exports.turquoise = '#1DD2B5';

var straw = exports.straw = '#FFFEF4';

var red = exports.red = '#E06D23';

var pink = exports.pink = '#FF00C8';

var orange = exports.orange = '#FFAB6F';

var purple = exports.purple = '#8357D6';

var violet = exports.violet = '#A270ff';

var lavender = exports.lavender = '#D8C4ff';

var orchid = exports.orchid = '#AE83FF';

var rgba = exports.rgba = function rgba(_ref) {
    var red = _ref.red,
        green = _ref.green,
        blue = _ref.blue,
        alpha = _ref.alpha;

    return 'rgba(' + red + ', ' + green + ', ' + blue + ', ' + alpha + ')';
};

var hexa = exports.hexa = function hexa(_ref2) {
    var _ref2$hex = _ref2.hex,
        hex = _ref2$hex === undefined ? '000000' : _ref2$hex,
        _ref2$alpha = _ref2.alpha,
        alpha = _ref2$alpha === undefined ? 0.5 : _ref2$alpha;

    if (hex.indexOf('#') === 0) {
        hex = hex.slice(1);
    }

    var bigint = parseInt(hex, 16);
    return rgba({
        red: bigint >> 16 & 255,
        green: bigint >> 8 & 255,
        blue: bigint & 255,
        alpha: alpha
    });
};
//# sourceMappingURL=colors.js.map